import { Add } from "@mui/icons-material";

const { Box } = require("@mui/material");

function ExpandIcon() {
  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid #111",
      }}
    >
      <Add sx={{ fontSize: 9 }} />
    </Box>
  );
}

export default ExpandIcon;
